import Modal from 'react-bootstrap/Modal';
import './logoutPopup.css';
import strings from "../../utils/property-file/logout.json";
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import SpinnerButtonMedium from '../button/SpinnerButtonMedium';
import { toast } from 'react-toastify';
import constants from '../../utils/constants';
import React from 'react';
import PropTypes from "prop-types";

export default function LogoutPopup(props) {
  const nav = useNavigate();
  const[loggingOut ,setLoggingOut] = useState(false);

  const logout = async () => {
    try {
        setLoggingOut(true);
        let response = await api.logout()
        if(response.success) {
          localStorage.clear();
          nav(constants.navigationLink.loginLink);
        }else{
          toast.error(strings.somethingWentWrongLabel ,{toastId : strings.errorLabel})
        }
        setLoggingOut(false);
    } catch (e) {
        setLoggingOut(false);
        toast.error(strings.somethingWentWrongLabel ,{toastId : strings.errorLabel})
        return e.response;
    }
}

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className='logout-popup'
      >
    <div className="main-container-logout">
        <div className="main-heading-logout">
        {strings.labelLogout}
        </div>
        <div className="logout-icon">
        <i className="ri-logout-circle-line logout-logo-icon"></i>
        </div>
        <div className="logout-message">
          {strings.labelWarning}
        </div>
        <div className="button-logout">
          <button className='stay-button all-button-logout'  onClick={props.onHide}>{strings.labelStay}</button>
          <button className='logout-button all-button-logout' disabled={loggingOut}  onClick={(()=>logout())}>{loggingOut? <SpinnerButtonMedium/>:strings.labelLogout}</button>
        </div>
    </div>
    </Modal>
  
  );
}


LogoutPopup.propTypes = {
  onHide : PropTypes.func.isRequired
}
